import { useLocation } from "react-router-dom";
import { Cell } from "react-table";
import { DeviceModel } from "src/api/iot/iot-types";
import { BaseTooltip } from "src/components";
import BaseNewTabLink from "src/components/BaseNewTabLink";
import { PagePath } from "src/pages/product/details";

const BuildingDeviceColumns: any[] = [
  {
    // 건물 디바이스(연결) id 가 아닌 실제 IoT ID(registeredDeviceId) 를 노출하고,
    // 선택 시 IoT 관리 > 해당 IoT ID 상세(기본정보 탭)로 이동한다.
    Header: "IoT ID",
    accessor: "registeredDeviceId",
    width: 80,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <BaseNewTabLink path={PagePath.iotConfig.detail.replace(":id", String(value))} value={String(value ?? "")} />;
    },
  },
  {
    // 기기 상세(제어 정보 / 실행권한 설정)를 새 탭으로 연다.
    // tabId 는 IoT ID(registeredDeviceId) 가 아닌 건물/상품/계약 디바이스 연결 id 여야 한다.
    Header: "실행권한",
    accessor: "",
    width: 100,
    Cell: ({ row }: Cell<any>) => {
      const location = useLocation();
      const search = location.search ? `${location.search}&` : "?";
      return <BaseNewTabLink path={`${location.pathname}${search}tabType=detail&tabId=${row.original.id}`} value="설정" ignoreQueryParams />;
    },
  },
  {
    Header: "건물명",
    accessor: "building.buildingName",
    width: 120,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <BaseTooltip contents={value} className="text-left w-100" />;
    },
  },
  {
    Header: "위치유형",
    accessor: "building.location.category",
    width: 80,
    Cell: ({ value }: Cell<DeviceModel>) => {
      let location = value === "FLOOR" ? "층" : value === "ROOM" ? "호실" : "공용공간";

      return <span>{location}</span>;
    },
  },
  {
    Header: "층",
    accessor: "building.floor",
    width: 80,
    Cell: ({ row }: Cell<any>) => {
      const notGround = String(row.original.building.floor).includes("-");
      const value = String(row.original.building.floor).replace("-", "");
      return <span>{!notGround ? ` 지상 ${value}층` : `지하 ${value}층`}</span>;
    },
  },
  {
    Header: "호",
    accessor: "building.ho",
    width: 80,
  },
  {
    Header: "공용공간 유형",
    accessor: "building.facility",
    width: 80,
    Cell: ({ value, row }: Cell<DeviceModel>) => {
      return <span>{value === "DESK" ? "좌석" : value === "MEETING_ROOM" ? "회의실" : value === "REFRESH_ROOM" ? "편의시설" : "-"}</span>;
    },
  },
  {
    Header: "공용공간",
    accessor: "building.location.facilityName",
    width: 160,
    Cell: ({ value, row }: Cell<DeviceModel>) => {
      const facilityName = row.original.building.facility === "DESK" ? `${row.original.building.location.deskGroupName} > ${value}` : value;
      return <BaseTooltip contents={facilityName} className="text-left w-100" />;
    },
  },
  {
    Header: "IoT 구분",
    accessor: "platformDevice.platformAccount.platform",
    width: 100,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <span>{value}</span>;
    },
  },
  {
    Header: "기기명",
    accessor: "internalDisplayName",
    width: 190,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return <span className="w-100 text-left">{value}</span>;
    },
  },
  {
    Header: "Device ID",
    accessor: "platformDevice.id",
    width: 160,
    Cell: ({ value }: Cell<DeviceModel>) => {
      return (
        <span style={{ wordBreak: "break-word" }} className="w-100 text-left font13">
          {value}
        </span>
      );
    },
  },
  {
    Header: "삭제",
    accessor: "",
    width: 60,
    Cell: ({ row, setConfirmModal }: any) => {
      return (
        <button
          className="base-trash-btn color-gray"
          onClick={(e) => {
            e.preventDefault();
            setConfirmModal({ isOpen: true, message: "삭제하시겠습니까?", payload: row.original.id });
          }}
        ></button>
      );
    },
  },
];

export default BuildingDeviceColumns;
